import React, {ReactNode, FunctionComponent} from 'react';
import _ from 'lodash';
import {Button} from '@treez-ui/core/buttons';
import {ButtonClass} from '@treez-ui/core/buttons/Button';
import {
    ThemeProvider,
    useTheme,
    Accordion,
    AccordionActions,
    AccordionDetails,
    AccordionSummary,
} from '@material-ui/core';
import {createTheme} from '@material-ui/core/styles';
import {ExpandMore} from '@material-ui/icons';
import ActionBarProductTable from './ActionBarProductTable';
import ActionBarCount from './ActionBarCount';

export interface Actions {
    action: () => void;
    title: string;
    icon?: any;
    buttonClass: ButtonClass;
}

interface Props {
    actions: ReactNode[];
    numberSelected: number;
    clearSelection: () => void;
}

export const ActionBar: FunctionComponent<Props> = (props: Props) => {
    const {actions, numberSelected, clearSelection} = props;

    const actionBarOverrides = createTheme({
        overrides: {
            MuiExpansionPanel: {
                root: {
                    width: '100%',
                    position: 'sticky',
                    bottom: 0,
                    zIndex: 500,
                    '&$expanded': {
                        margin: 0,
                    },
                    '&:before': {
                        opacity: 0,
                    },
                },
            },
            MuiExpansionPanelSummary: {
                root: {
                    backgroundColor: '#f6f6f6',
                },
                content: {
                    justifyContent: 'space-between',
                    margin: '0.6rem 0',
                    '&$expanded': {
                        margin: '0.6rem 0',
                    },
                },
                expandIcon: {
                    transform: 'rotate(180deg)',
                    '&$expanded': {
                        transform: 'rotate(0deg)',
                    },
                },
            },
            MuiExpansionPanelDetails: {
                root: {
                    maxHeight: '33vh',
                    overflow: 'scroll',
                },
            },
            MuiTable: {
                root: {
                    borderCollapse: 'unset',
                },
            },
        },
    });

    const theme = {...useTheme(), ...actionBarOverrides};

    return (
        <ThemeProvider theme={theme}>
            <Accordion elevation={8} className="action-bar">
                <AccordionSummary
                    expandIcon={<ExpandMore />}
                    aria-controls="action-bar-content"
                    id="action-bar-header"
                >
                    <div className="selectionDetails">
                        <ActionBarCount count={numberSelected} objectTitle="product" />
                        {clearSelection && (
                            <Button
                                buttonClass={ButtonClass.QUIET}
                                disabled={numberSelected === 0}
                                onClick={clearSelection}
                                text="Clear Selection"
                            />
                        )}
                    </div>
                    <AccordionActions>{actions}</AccordionActions>
                </AccordionSummary>
                <AccordionDetails>
                    <ActionBarProductTable />
                </AccordionDetails>
            </Accordion>
        </ThemeProvider>
    );
};

export default ActionBar;
